export default __webpack_public_path__ + "the-right-tech-data-for-app-support.jpg";